import React from 'react';
import { SegmentedProps } from 'antd';
import { StyledSegmented } from './styles';

interface Props extends SegmentedProps {}

const Segmented: React.FC<Props> = (props) => {
    return <StyledSegmented {...(props as any)} />;
};

export default Segmented;
